module.exports = __webpack_public_path__ + "img/Purpurbräcka.71ab8526.jpg";